import useSWR from 'swr';
// logic
import getTicketDetail from 'modules/emergencies/api/getTicketDetail';
import ticketService from 'modules/emergencies/ticketService';
import { SETTINGS } from 'modules/emergencies/constants';

// returns ticket with loading/reloading state
const useGetBids = (id) => {
  const { data: ticket, error: getTicketError } = useSWR(
    `bids/ticket/${id}`,
    () => getTicketDetail({ id }),
    {
      refreshInterval: SETTINGS.RELOAD_TICKETS_LIST_INTERVAL_IN_SECONDS * 1000,
      revalidateAll: true,
      revalidateIfStale: true,
    }
  );

  const isLoadingTicket = typeof ticket === 'undefined' && !getTicketError;
  let bids = ticketService.bussiness.getBids(ticket);

  return { bids, isLoadingTicket };
};

export default useGetBids;
